import type { KnowledgeNode } from "./types"

// Django FileResponse emits UTF-8 filename* or a quoted, escaped filename.
export const getOriginalDownloadFileName = (headers: Headers): string => {
  const disposition = headers.get("Content-Disposition") || ""
  const encoded = disposition.match(/;\s*filename\*=UTF-8''([^;]+)/i)
  const quoted = disposition.match(/;\s*filename="((?:\\.|[^"\\])*)"/i)
  const name = encoded
    ? decodeURIComponent(encoded[1])
    : quoted?.[1].replace(/\\(.)/g, "$1")
  if (!name) throw new Error("Original download filename is unavailable")
  return name.replace(/[\\/]/g, "_")
}

export const isUploadedFileNode = (node: KnowledgeNode) =>
  node.node_type === "FILE" && node.source_type === "LOCAL_UPLOAD"

export const getKnowledgeBaseDownloadLabelKey = (nodes: KnowledgeNode[]) => {
  const files = nodes.filter((node) => node.node_type === "FILE")
  if (files.length === 0 || files.every(isUploadedFileNode)) {
    return "knowledgeBase.treeView.download"
  }
  return files.some(isUploadedFileNode)
    ? "knowledgeBase.treeView.downloadMixed"
    : "knowledgeBase.treeView.downloadTextSnapshot"
}
